<template>
    <div v-show="list.length" class="InfiniteScroll" ref="infiniteScrollRef">
        <div ref="scrollParentBox" class="scroll_parent_box" @mouseenter="mEnter" @mouseleave="mLeave">
            <div class="scroll_list" :style="{ transform: `translate(0px,-${scrollTop}px)` }">
                <div ref="scrollItemBox">
                    <div v-for="(item, index) in list" :key="index" class="scroll_item" ref="scrollItemRef">
                        <slot name="scrollInner" :item="item" >{{ item.title }}</slot>
                    </div>
                </div>
                <div v-if="scrollItemBox && isScroll" v-html="copyHtml" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'InfiniteScroll',
  props: {
    list: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      scrollTop: 0, // 列表滚动高度
      copyHtml: '', // 复制多一份防止滚动到后面出现空白
      scrollItemBox: null,
      scrollParentBox: null,
      scrollItemRef:null,
      infiniteScrollRef:null,
      animationId:null
    }
  },
  computed: {
    isScroll(){
      return this.scrollItemRef?.getBoundingClientRect().height * this.list.length > this.infiniteScrollRef?.parentElement?.getBoundingClientRect().height
    }
  },
  watch:{
    list:{
      handler(n){
        if(n.length){
          this.$nextTick(()=>{
            this.initScroll()
          })
        }
      },
      immediate:true
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
    initScroll() {
      this.stopScroll()
      this.scrollTop = 0
      this.$nextTick(() => {
        this.infiniteScrollRef = this.$refs.infiniteScrollRef
        this.scrollItemBox = this.$refs.scrollItemBox
        this.scrollItemRef = this.$refs.scrollItemRef?.[0]
        this.copyHtml = this.scrollItemBox.innerHTML
        this.startScroll()
      })
    },
    // 鼠标移入停止滚动
    mEnter() {
      this.stopScroll()
    },
    // 鼠标移出继续滚动
    mLeave() {
      this.startScroll()
    },
    // 开始滚动
    startScroll() {
      if (this.isScroll) {
        this.scroll()
      }
    },
    // 停止滚动
    stopScroll(){
      cancelAnimationFrame(this.animationId)
    },
    // 处理滚动方法
    scroll() {
      this.scrollTop++
      // 当判断滚动的高度大于等于盒子高度时，从头开始滚动
      if (this.scrollTop >= this.scrollItemBox.offsetHeight) {
        this.scrollTop = 0
      }
      this.animationId = requestAnimationFrame(this.scroll)
    }
  }
}
</script>

<style scoped>
.InfiniteScroll {
    box-sizing: border-box;
}

.scroll_parent_box {
    overflow: hidden;
    box-sizing: border-box;
}

.scroll_list {
    transition: all 0ms ease-in 0s
}

.scroll_item {
    font-size: 14px;
}
</style>
